import { Injectable } from '@angular/core';
import {
  ThresholdByProductId,
  ThresholdDTO,
  CreateOrUpdateThreshold,
} from '@dto/threshold/threshold.dto';
import { environment } from '@environments/environment';
import { map, Observable } from 'rxjs';
import { AuthHttpClientService } from './auth-http-client.service';
import { RateType } from '@type/rate.type';

@Injectable({
  providedIn: 'any',
})
export class ThresholdService {
  private readonly url: string = `${environment.tmnBackApi}/thresholds`;

  constructor(private readonly http: AuthHttpClientService) { }

  getThresholds(productIds: string[]): Observable<ThresholdByProductId> {
    const queryParams = productIds.join(',');
    const urlWithParams = `${this.url}?productIds=${encodeURIComponent(
      queryParams
    )}`;

    return this.http
      .get<ThresholdDTO>(urlWithParams)
      .pipe(map((response) => response.productIds ?? {}));
  }

  upsertThreshold(threshold: CreateOrUpdateThreshold): Observable<void> {
    const urlWithParams = `${this.url}?productId=${encodeURIComponent(
      threshold.productId
    )}`;
    return this.http.post<void>(urlWithParams, threshold);
  }

  updatePriority(productId: string, eventType: string, priority: number): Observable<void> {
    const url = `${this.url}/event-type-priority?productId=${encodeURIComponent(productId)}&eventType=${encodeURIComponent(eventType)}&priority=${priority}`;
    return this.http.put<void>(url);
  }

  deleteThreshold(
    productId: string,
    eventType: string,
    indicatorName: RateType,
    triggerType: string
  ): Observable<void> {
    const url = `${this.url}?productId=${encodeURIComponent(productId)}&eventType=${encodeURIComponent(eventType)}&indicatorName=${encodeURIComponent(indicatorName)}&triggerType=${encodeURIComponent(triggerType)}`;
    return this.http.delete<void>(url);
  }
}
